// // // // export const apiUrl = 'http://192.168.1.47:8000/api';
// export const apiUrl = 'http://127.0.0.1:8084';
// export const domainUrl = 'http://127.0.0.1:8084';

// local testing 
// export const apiUrl = 'http://192.168.1.30:8084';
// export const domainUrl = 'http://192.168.1.30:8084';

// export const apiUrl = 'https://newexult.corientbiz.com';
// export const domainUrl = 'https://newexult.corientbiz.com';



 export const apiUrl = 'https://externalexult.corientbiz.com';
 export const domainUrl = 'https://externalexult.corientbiz.com';

